module.exports = __webpack_public_path__ + "img/jbxxbeijing.a8dd917f.png";